import React, { useContext, useState } from "react";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import Context from "../../../../../Context";

export default function RecursiveTreeView(props) {
  let items = props.data || {};

  let cx = useContext(Context);

  const [expanded, setExpanded] = useState(
    props.navigate ? [props.navigate] : ["root"]
  );
  const [selected, setSelected] = useState(
    props.navigate ? [props.navigate] : []
  );

  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  const handleSelect = (event, nodeIds) => {
    setSelected(nodeIds);
  };

  function getChildren(itemId) {
    let children = [];
    for (let id in items) {
      let item = items[id];
      if (item.parent === itemId) children.push(item);
    }
    return children;
  }

  function change(id) {
    if (props.changeFn) props.changeFn(id);
  }

  function makeNodeId(item) {
    return !item.parent ? "root" : String(item.id);
  }

  const renderTree = (item) => (
    <TreeItem
      onClick={() => change(item.id)}
      key={item.id}
      nodeId={makeNodeId(item)}
      label={item.name}
      className="my-2"
    >
      {getChildren(item.id).map((item) => renderTree(item))}
    </TreeItem>
  );

  return (
    <TreeView
      defaultCollapseIcon={<i className="fa fa-angle-down"></i>}
      defaultExpandIcon={<i className="fa fa-angle-right"></i>}
      expanded={expanded}
      selected={selected}
      onNodeToggle={handleToggle}
      onNodeSelect={handleSelect}
    >
      {Object.entries(items).map(([id, item]) =>
        item.level === 0 ? renderTree(item) : null
      )}
    </TreeView>
  );
}
